import Home from './views/home/Home';
import Equipments from './views/equipment/Equipments';
import Users from 'views/user/Users';
import CreateUser from './views/user/CreateUser';
import ParamAlarmIndice from './views/parameter/ParamAlarmIndice';
import ParamAcquitalReason from './views/parameter/ParamAcquitalReason';
import EquipmentDetail from './views/equipment/EquipmentDetail';
import CreateOT from 'views/equipment/CreateOT';
import ParamCommand from './views/parameter/ParamCommand';
import CreateOrEditCommand from './views/parameter/CreateOrEditCommand';

const routes = {
  Accueil: {
    component: Home,
    path: '/accueil',
  },
  Equipments: {
    component: Equipments,
    path: '/equipements',
    params: {
      color: '#0094ca'
    }
  },
  EquipmentDetail: {
    component: EquipmentDetail,
    path: '/equipement/:id',
    params: {
      color: '#0094ca'
    }
  },
  CreateOT: {
    component: CreateOT,
    path: '/equipement/ot/creation/:id',
    params: {
      color: '#0094ca'
    }
  },
  Users: {
    component: Users,
    path: '/utilisateurs',
    params: {
      color: '#0094ca'
    }
  },
  CreateUser: {
    component: CreateUser,
    path: '/utilisateurs/creation',
    params: {
      color: '#0094ca'
    }
  },
  AlarmIndice: {
    component: ParamAlarmIndice,
    path: '/parametres/gestion-indice-gravite',
    params: {
      color: '#0094ca'
    }
  },
  AcquitalReason: {
    component: ParamAcquitalReason,
    path: '/parametres/gestion-motif-acquittement',
    params: {
      color: '#0094ca'
    }
  },
  Command: {
    component: ParamCommand,
    path: '/parametres/gestion-commandes-references',
    params: {
      color: '#0094ca'
    }
  },
  CreateCommand: {
    component: CreateOrEditCommand,
    path: '/parametres/gestion-commandes-references/creation',
    params: {
      color: '#0094ca'
    }
  },
  EditCommand: {
    component: CreateOrEditCommand,
    path: '/parametres/gestion-commandes-references/edition/:id',
    params: {
      color: '#0094ca'
    }
  },
};

export default routes;